module.exports = __webpack_public_path__ + "img/venus_media_collection_white.3f1657be.svg";